// Beehive block (MB.5). PURE (ENG-1). The honey-level machine + the pollination
// growth boost a bee triggers when it delivers nectar home, plus honey harvest.
// The bee AI itself lives in game/bee.ts; this owns the hive block's side.
import { HIVE_GROWTH_RADIUS } from './bee';

/** A hive fills to five honey before it can be harvested (Java). */
export const HONEY_MAX = 5;
/** Ticks between a resident bee's nectar deposits (host cadence). */
export const DEPOSIT_INTERVAL = 200;

/** Honey level after one nectar deposit, capped. */
export function nextHoney(level: number): number {
  return Math.min(HONEY_MAX, Math.max(0, Math.floor(level)) + 1);
}

/** A hive is ready to harvest once full. */
export function honeyFull(level: number): boolean {
  return level >= HONEY_MAX;
}

/** What working a *full* hive with `tool` yields (shears → comb, bottle → honey),
 *  or null if the tool can't harvest it. The host then resets the level to 0. */
export function harvestYield(tool: string | undefined): { item: string; count: number } | null {
  if (tool === 'shears') return { item: 'honeycomb', count: 3 };
  if (tool === 'glass_bottle') return { item: 'honey_bottle', count: 1 };
  return null;
}

/** Cells around a hive a nectar delivery bonemeal-nudges (horizontal Chebyshev
 *  radius `r`, ±1 vertical) — the host advances any crop it finds among them. */
export function boostCells(hx: number, hy: number, hz: number, r = HIVE_GROWTH_RADIUS): Array<{ x: number; y: number; z: number }> {
  const cells: Array<{ x: number; y: number; z: number }> = [];
  for (let dx = -r; dx <= r; dx++) {
    for (let dz = -r; dz <= r; dz++) {
      for (let dy = -1; dy <= 1; dy++) {
        if (dx === 0 && dy === 0 && dz === 0) continue;
        cells.push({ x: hx + dx, y: hy + dy, z: hz + dz });
      }
    }
  }
  return cells;
}
